<div class="titled-input-wrapper {{ type }}"
  [ngClass]="{ 'disabled': isDisabled, 'invalid':isInvalid}">
  <ng-container *ngIf="title">
    <div class="title-container">
      <label class="titled-input-label">{{ title }}</label>
      <div class="tooltip-icon-container">
        <ng-content select="app-tooltip-icon"></ng-content>
      </div>
    </div>
  </ng-container>
  <ng-content></ng-content>
  <!-- Only render the error line when there's an actual message. Some validators (e.g. async page-id
       checks) flag the control invalid without a `message`; without this guard that produced an empty
       red line that added height and broke sibling layout. -->
  <div class="error" *ngIf="isInvalid && errorMessage"> {{ errorMessage }}</div>
  <!-- Slot for a consumer-authored note below the field (e.g. the "brand name was changed" refresh
       prompt). It sits under the validation line and, unlike it, is not driven by control state — the
       consumer decides when to render it and owns its wording. -->
  <ng-content select="[inputNote]"></ng-content>
</div>
